import { render, staticRenderFns } from "./SimList.vue?vue&type=template&id=5439247e&scoped=true"
import script from "./SimList.vue?vue&type=script&lang=js"
export * from "./SimList.vue?vue&type=script&lang=js"
import style0 from "./SimList.vue?vue&type=style&index=0&id=5439247e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5439247e",
  null
  
)

export default component.exports